import React from 'react'
import Main from './Review/Main'

function App() {
  return (
    <div>
      <Main/>
    </div>
  )
}

export default App
